import React from "react";
import { useParams, Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { CancelRequest } from "../../../services/AxiosInstance";
import Pagination from "../../Constant/Pagination";
import DebounceSmallSearchInput from "../../Constant/DebounceSmallSearchInput";
import format from "date-fns/format";
import {
  AssetMovementHistoryApi,
  getAssetMovementHistoryExport,
} from "../../../services/AssetService";
import { formatDateTimeWithAdd5Hours } from "../../../utilities";
import { FaDownload } from "react-icons/fa";
import GlobalSearchableDropdown from "../../Constant/SearchableDropdown";
import { toast } from "react-toastify";
const logDetails = (log) => {
  const { log_type, log_details } = log;

  switch (log_type) {
    case "ASSIGNED":
      return (
        <>
          <strong>Allocation Type:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.allocation_type || "-"}{" "},
          </span>
          <strong>Allocated To:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.allocated_to?.fullname || "-"} (
            {log_details?.allocated_to?.email || "-"})
          </span>
        </>
      );

    case "MOVED":
      return (
        <>
          <strong>From:</strong>{" "}
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {log_details?.from_location || "-"},
          </span>{" "}
          <strong>To:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.to_location || "-"},
          </span>{" "}
          <strong>Status:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {log_details?.movement_status || "-"}
          </span>
        </>
      );

    case "RETURNED":
      return (
        <>
          <strong>Status:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.return_status || "-"},
          </span>{" "}
          <strong>Remarks:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.remarks || "—"}
          </span>
        </>
      );

    case "MAINTENANCE":
      return (
        <>
          <strong>Type:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {log_details?.maintenance_type || "-"}
          </span>{" "},
          <strong>Cost:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            ₹{log_details?.cost || "-"}{" "},
          </span>
          <strong>Start:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {log_details.start_date
              ? format(log_details.start_date, "dd MMM yyy")
              : "-"},
          </span>{" "}
          <strong>End:</strong>{" "}
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {log_details.end_date
              ? format(log_details.end_date, "dd MMM yyy")
              : "-"},
          </span>{" "}
          <strong>Description:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.description || "-"}
          </span>
        </>
      );

    case "DISPOSED":
      return (
        <>
          <strong>Unit Missing:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details.is_unit_missing ? "Yes" : "No"}
          </span>{" "}
          <br />
          <strong>Total Life Span:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.total_life_span || "-"}
          </span>
        </>
      );
    
    case "TRANSFERRED":
      return (
        <>
          <strong>From:</strong>{" "}
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>

            {log_details?.from_employee || "-"},
          </span>{" "}
          <strong>To:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {" "}
            {log_details?.to_employee || "-"},
          </span>{" "}
          <strong>Status:</strong>
          <span className="fw-medium text-dark" style={{ fontSize: "0.8rem" }}>
            {log_details?.movement_status || "-"}
          </span>
        </>
      );
    default:
      return "—";
  }
};
const typeoPtion = [
  { label: "Assigned", value: "ASSIGNED" },
  { label: "Moved", value: "MOVED" },
  { label: "Returned", value: "RETURNED" },
  { label: "Maintenance", value: "MAINTENANCE" },
  { label: "Disposed", value: "DISPOSED" },
  { label: "Transferred", value: "TRANSFERRED" },
];
const AssetHistory = () => {
  const { id } = useParams();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [exportloading, setExportloading] = useState(false);
  const [logTypeOption, setLogTypeOption] = useState(typeoPtion);
  const [selectedLogType, setSelectedLogType] = useState(null);

  const [param, setParam] = useState({
    query: "",
    page: "1",
    page_size: "10",
    log_type: "",
  });
  const getInsuranceList = () => {
    setLoading(true);
    AssetMovementHistoryApi(id, param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getInsuranceList();
  }, [param]);
  useEffect(() => {
    const logType = selectedLogType?.value || "";
    if (param.log_type !== logType) {
      setParam({ ...param, log_type: logType });
    }
  }, [selectedLogType]);
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleExport = () => {
    setExportloading(true);
    getAssetMovementHistoryExport(id, { ...param, export: true })
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Asset-Movement-History.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportloading(false);
      });
  };
  return (
    <div className="card">
      <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
        <div className="flex-fill flex-sm-grow-0">
          <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
        </div>
        <div className="d-flex flex-wrap gap-2">
          <GlobalSearchableDropdown
            options={logTypeOption}
            selected={selectedLogType}
            onSelect={setSelectedLogType}
            placeholder="Log Type"
          />
          <button
            className="btn btn-success d-flex align-items-center gap-1 align-self-center"
            style={{ padding: "0.4rem 0.6rem" }}
            onClick={handleExport}
            disabled={exportloading||!data?.length>0}
          >
            {exportloading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <FaDownload />
            )}
            Export
          </button>
        </div>
      </div>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : error ? (
        <div className="text-center text-danger my-4">{error}</div>
      ) : data && data.length > 0 ? (
        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>Date</th>
                <th>Performed By</th>
                <th>Log Type</th>
                <th>Log Details</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item?.created_at
                      ? formatDateTimeWithAdd5Hours(item?.created_at)
                      : "-"}
                  </td>
                  <td>{item?.performed_by?.fullname || "-"}</td>
                  <td>
                    <LogTypeBadge logType={item?.log_type} />{" "}
                  </td>
                  <td>{logDetails(item)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center my-4">
          <span>No data found</span>
        </div>
      )}

      {!loading && data?.length > 0 && (
        <div className="p-4">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default AssetHistory;

const LogTypeBadge = ({ logType }) => {
  switch (logType) {
    case "ASSIGNED":
      return <span className="badge bg-info-subtle text-info">ASSIGNED</span>;
    case "RETURNED":
      return (
        <span className="badge bg-primary-subtle text-primary">RETURNED</span>
      );
    case "MOVED":
      return (
        <span className="badge bg-warning-subtle text-secondary">MOVED</span>
      );
    case "MAINTENANCE":
      return (
        <span className="badge bg-warning-subtle text-warning">
          MAINTENANCE
        </span>
      );
      case "TRANSFERRED":
      return (
        <span className="badge bg-warning-subtle text-warning">
          TRANSFERRED
        </span>
      );
    default:
      return (
        <span className="badge bg-danger-subtle text-danger">DISPOSED</span>
      );
  }
};
